import { LogLevel, LogLevelValueFromString } from './consts';

export function shouldLog(level: LogLevel, loggerLevel: LogLevel): boolean {
  return getLogValue(level) <= getLogValue(loggerLevel);
}

export function getLogValue(level: LogLevel): number {
  return LogLevelValueFromString[level];
}
